// @dynamic
var AppConsts = /** @class */ (function () {
    function AppConsts() {
    }
    Object.defineProperty(AppConsts, "useHttps", {
        get: function () {
            if (!AppConsts.appBaseUrl) {
                throw new Error('appBaseUrl is null');
            }
            return AppConsts.appBaseUrl.indexOf('https') === 0;
        },
        enumerable: true,
        configurable: true
    });
    AppConsts.tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';
    AppConsts.localeMappings = [];
    AppConsts.userManagement = {
        defaultAdminUserName: 'admin'
    };
    AppConsts.localization = {
        defaultLocalizationSourceName: 'Platform',
        deviceLocalizationSourceName: 'Device',
        configureLocalizationSourceName: 'Configure',
        fboxLocalizationSourceName: 'FBox',
        statisticLocalizationSourceName: 'Statistics',
        salesCenterLocalizationSourceName: 'SalesCenter',
        knowledgeLocalizationSourceName: 'KnowledgeBase',
        notificationSourceName: 'Notification',
        reportsLocalizationSourceName: 'Reports',
        organizationLocalizationSourceName: 'Organization'
    };
    AppConsts.authorization = {
        encrptedAuthTokenName: 'enc_auth_token',
        rememberMeName: 'remember_me'
    };
    AppConsts.grid = {
        defaultPageSize: 10
    };
    AppConsts.defaultRemainingSeconds = 60;
    AppConsts.twoFactorProviders = {
        email: 'Email',
        phone: 'Phone'
    };
    AppConsts.customTitleInfo = 'custom_title_info_of_table';
    return AppConsts;
}());
export { AppConsts };
